(function () {
	'use strict';

	angular.module('dcApp').directive('gaugecircularchartview', [
		'$parse',
		function ($parse) {
			var controller = [
				'$scope',
				'$state',
				'ChartService',
				'hdSourceService',
				'$window',
				'PermissionService',
				'ChartViewCommonFactory',
				'gettextCatalog',
				'$filter',
				'$timeout',
				'DX_RERENDER_TIMEOUT',
				function (
					$scope,
					$state,
					ChartService,
					hdSourceService,
					$window,
					PermissionService,
					ChartViewCommonFactory,
					gettextCatalog,
					$filter,
					$timeout,
					DX_RERENDER_TIMEOUT
				) {
					var vm = this;
					vm.init = function (ignoreCache) {
						ChartViewCommonFactory.initialize(
							'gauge_circular',
							$scope,
							checkConfig,
							loadGroupDataInChart,
							ignoreCache
						);
					};

					ChartViewCommonFactory.initializeDirectiveScope(
						$scope,
						vm,
						'gauge_circular'
					);

					$scope.showPopover = function ($event, obj) {
						if (Object.keys(obj).length === 0) {
							$scope.noFilterApplied = true;
						} else {
							$scope.noFilterApplied = false;
						}
						// Set a bigger z-index
						$(function () {
							DevExpress.ui.dxOverlay.baseZIndex(1999999998);
						});
					};

					function initPopover() {
						$scope.sourceCentring = vm.data.centering
							? vm.data.centering.source_centering
							: {};
						$scope.filterDetailsPopover = {
							target: '#filterInfoPopover' + $scope.uuid,
							showEvent: 'dxclick',
							position: 'top',
							width: 450,
							bindingOptions: {
								visible: 'visibleMetaData',
							},
						};
					}

					var loadGroupDataInChart = function (data) {
						$scope.config.global.tooltip = { enabled: true };
						initPopover();
						if (data[0]) {
							$scope.config.global.value = data[0][$scope.config.global.value];
							var subvalues = [];
							for (var sv in $scope.config.global.subvalues) {
								subvalues.push(
									data[0][$scope.config.global.subvalues[sv].value]
								);
							}

							if ($scope.config.global.scale) {
								$scope.config.global.scale.startValue =
									data[0][$scope.config.global.scale.startValue];
								$scope.config.global.scale.endValue =
									data[0][$scope.config.global.scale.endValue];
							}

							$scope.config.global.subvalues = subvalues;
							for (var r in $scope.config.global.ranges) {
								$scope.config.global.ranges[r].startValue =
									data[0][$scope.config.global.ranges[r].startValue];
								$scope.config.global.ranges[r].endValue =
									data[0][$scope.config.global.ranges[r].endValue];
								if (
									$scope.config.global.ranges[r].colorColumn &&
									data[0][$scope.config.global.ranges[r].colorColumn]
								) {
									$scope.config.global.ranges[r].color =
										data[0][$scope.config.global.ranges[r].colorColumn];
								}
								delete $scope.config.global.ranges[r].colorColumn;
							}
						}

						$scope.config.global.rangeContainer = {
							ranges: $scope.config.global.ranges,
						};
						delete $scope.config.global.ranges;

						$scope.dxChartOptions = $scope.config.global;

						$('#chart' + $scope.uuid).dxCircularGauge($scope.dxChartOptions);
						$timeout(function () {
							$('#chart' + $scope.uuid)
								.dxCircularGauge('instance')
								.render();
						}, DX_RERENDER_TIMEOUT);

						ChartViewCommonFactory.chartAutoResizing(
							$scope,
							$('#chart' + $scope.uuid).dxCircularGauge('instance'),
							DX_RERENDER_TIMEOUT
						);

						return true;
					};

					var checkConfig = function (config) {
						return true;
					};
				},
			];

			return buildDirectiveReturnObject(
				{ data: '=' },
				controller,
				'./src/components/directives/handledata/chartView/gauge_circular/chartView.html',
				function postLink(scope, element, attrs) {
					if (!scope.vm.data.full_data) {
						scope.jobDetails = { rerunMethod: scope.rerunWithoutCache };
						scope.jobDetailsId = generateUuid('_');
					}
					const ignoreCache = scope.vm.data.ignoreCache || false;
					scope.vm.init(ignoreCache);
				}
			);
		},
	]);
})();
